var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 4.16602H6.66683C3.44517 4.16602 0.833496 6.77769 0.833496 9.99935C0.833496 13.221 3.44517 15.8327 6.66683 15.8327H13.3335C16.5552 15.8327 19.1668 13.221 19.1668 9.99935C19.1668 6.77769 16.5552 4.16602 13.3335 4.16602Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 12.5C8.0477 12.5 9.16699 11.3807 9.16699 10C9.16699 8.61929 8.0477 7.5 6.66699 7.5C5.28628 7.5 4.16699 8.61929 4.16699 10C4.16699 11.3807 5.28628 12.5 6.66699 12.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.0468dd39ee604a9dab14373b11765849.svg";
export { ForwardRef as ReactComponent };